import React from "react";
import { Navigate, Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useFavorites } from "@/context/FavoritesContext";
import api from "@/lib/api";
import PropertyCard from "@/components/PropertyCard";

export default function Favorites() {
  const { user, loading } = useAuth();
  const { ids } = useFavorites();
  const [projects, setProjects] = React.useState([]);
  const [loadingList, setLoadingList] = React.useState(true);

  React.useEffect(() => {
    if (!user || user === false) return;
    if (ids.size === 0) {
      setProjects([]);
      setLoadingList(false);
      return;
    }
    api.get(`/projects/compare?ids=${[...ids].join(",")}`)
      .then((r) => setProjects(r.data || []))
      .finally(() => setLoadingList(false));
  }, [ids, user]);

  if (loading) return <div className="py-32 text-center text-slate-500">Loading…</div>;
  if (!user || user === false) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen pb-32" data-testid="favorites-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-12">
        <div className="overline mb-3">Saved by you</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-slate-900 flex items-center gap-3">
          <Heart className="w-8 h-8 text-[#D4A437]" strokeWidth={1.5} fill="currentColor" /> Favorites
        </h1>
        <p className="text-slate-600 mt-3 max-w-2xl font-light">{ids.size} saved {ids.size === 1 ? "project" : "projects"}.</p>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16">
        {loadingList ? (
          <div className="text-slate-500 py-12">Loading…</div>
        ) : projects.length === 0 ? (
          <div className="border border-slate-200 p-12 text-center">
            <h3 className="font-serif text-2xl text-slate-900 mb-3">No favorites yet</h3>
            <p className="text-slate-600 mb-6">Tap the heart icon on any project to save it here.</p>
            <Link to="/projects" className="inline-block px-6 py-3 bg-[#D4A437] text-white hover:bg-[#D4A437]" data-testid="fav-browse-cta">
              Browse Projects →
            </Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((p) => <PropertyCard key={p.id} project={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
